import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from "jwt-decode";
import { CredentialResponse } from '@react-oauth/google';
import { loginWithGoogle } from '../api/api';
import { User } from '../types';

// Định nghĩa những gì Context sẽ cung cấp
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  token: string | null;
  isLoading: boolean;
  login: (credentialResponse: CredentialResponse) => void;
  logout: () => void;
}

// Tạo Context
const AuthContext = createContext<AuthContextType | null>(null);

// Tạo Provider Component
export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(localStorage.getItem('app_token'));
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    // Kiểm tra xem có thông tin user trong localStorage không khi tải lại trang
    // const storedUser = localStorage.getItem('user');
    // if (token && storedUser) {
    //   setUser(JSON.parse(storedUser));
    // }
    try {
      const storedToken = localStorage.getItem('app_token');
      const storedUser = localStorage.getItem('user');

      if (storedToken && storedUser) {
        setToken(storedToken);
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error("Failed to load auth state from storage", error);
    } finally {
      setIsLoading(false); // <-- Đánh dấu đã kiểm tra xong
    }
  }, [token]);

  const login = async (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      // // Giải mã token để lấy thông tin user (chỉ cho mục đích demo ở frontend)
      // const decoded: User = jwtDecode(credentialResponse.credential);
      // const userData = {
      //   name: decoded.name,
      //   email: decoded.email,
      //   picture: decoded.picture,
      // };

      // localStorage.setItem('user', JSON.stringify(userData)); // Lưu thông tin vào localStorage
      // setUser(userData);
      // **LƯU Ý:** Ở ứng dụng thực tế, bạn sẽ gửi token này đến backend để xác thực
      // và nhận về một JWT của riêng bạn.
      // Gửi IdToken đến backend
      try {
        const { token: newToken, user: userData, } = await loginWithGoogle(credentialResponse.credential);

        const decoded: User = jwtDecode(credentialResponse.credential);
        if (userData) {
          userData.picture = decoded.picture;
        }

        localStorage.setItem('app_token', newToken);
        localStorage.setItem('user', JSON.stringify(userData));

        setToken(newToken);
        setUser(userData);
      } catch (error) {
        console.error("Authentication failed:", error);
        logout(); // Đảm bảo dọn dẹp nếu đăng nhập thất bại
      }
    }
  };

  const logout = () => {
    localStorage.removeItem('user'); // Xóa thông tin khỏi localStorage
    localStorage.removeItem('app_token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticated: !!user, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Tạo một custom hook để dễ dàng sử dụng context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};